const FormPrice = (price) => {
    let label = new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(price)
    return label
}

export default FormPrice